export default {
  label: {
    header: {
      title: 'Acessos',
      button: 'Criar acesso'
    },
    subtitle: 'Nessa página você pode criar acessos de clientes ao onboarding do Studio.',
    input: {
      placeholder: 'Buscar usuário',
    },
    table: {
      accountId: 'Id da conta',
      universeId: 'Id da pesquisa',
      createdDate: 'Data de criação',
      environment: 'Ambiente',
      homologEnv: 'Homologação',
      prodEnv: 'Produção',
      email: 'E-mail',
      onboarding: 'Onboarding',
    },
    modal: {
      title: 'Criar acesso',
    },
  },
  notification: {
    loadingData: 'Carregando dados...',
    removeAccess: 'O acesso foi excluído com sucesso.',
  },
  dialog: {
    title: 'Excluir acesso?',
    text: 'Ao excluir esse acesso, o usuário não poderá entrar no Studio e prosseguir com o onboarding.',
    primaryButtonLabel: 'Excluir',
    secondaryButtonLabel: 'Cancelar',
  }
};
